import React  from 'react';

import Layout from '../components/layouts/standard-page.js';
import ContentLayout from '../components/layouts/content-standard-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHead from '../components/card-header.js';
import LanguageSelector from '../components/inputs/language-selector.js';
import {Modal , Row , Col , Alert , FormGroup , ControlLabel , FormControl , Button} from 'react-bootstrap';
import ContentService from '../services/content-service.js';
import ContentStore   from  '../store/content-store.js';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import InternationalizationStore from '../store/internationalization-store.js';
import { FormattedMessage } from 'react-intl';
import VocabObject from '../components/content-simple-vocab.js';

export default class ContentBuilderOverview extends React.Component{

    constructor(props) {
        super(props);

        this.state = {catalog:ContentStore.getCatalog(this.props.catalogUID) , show:false, catalogID:this.props.params.classID , savingContent:false, name:"" , learningLanguage:{ietf:null},supportLanguage:{ietf:null} , modules:[] };
    }

    componentDidMount() {
        ContentService.fetchModules(this.props.params.classID)
    }

    componentWillMount(){
        ContentStore.on("ON_MY_CONTENT_UPDATE" , () => {
            this.setState({modules : ContentStore.modules})
        });

        ContentStore.on('ON_VOCAB_FETCH'  , () => {

            this.setState({
                catalog:ContentStore.getCatalog(this.state.catalogUID)
            })

        });


        ContentStore.on('ON_SUMMARY_FETCH'  , () => {

            this.setState({
                title:ContentStore.getCatalogSummary(this.state.catalogUID).summary.title,
            });

        });
    }


    handleLearningChange(learningLanguage){
        this.setState({learningLanguage:learningLanguage});
    }

    handelSupportChange(supportLanguage){
        this.setState({supportLanguage:supportLanguage});
    }

    handleChange(e) {
        this.setState({ name: e.target.value });
    }


    handleDescripitonChange(e){
        this.setState({ description: e.target.value });
    }

    handleSubmit(){

        if(this.state.name.length == 0)
        {
            return;
        }

        ContentService.makeNewModule(this.state.name , this.state.learningLanguage.ietf , this.state.supportLanguage.ietf).then(function(response){

            this.gotoCheckout(response.uid);



        }.bind(this))

    }

    getTableData(){
        return [];
    }

    languageImage(cell, row) {
        return <img className="avatar-img" src={"img/flags/"+cell+".png"} alt=""/>
    }

    editButton(cell, row){
        return <button type="button" onClick={this.gotoCheckout.bind(this , cell)} className="btn btn-icon command-delete waves-effect waves-circle" data-row-id="10253"><span className="zmdi zmdi-edit"></span></button>
    }

    seeButton(cell, row){

        return <button onClick={this.onVocabSelect.bind(this , row)} type="button" className="btn btn-icon command-delete waves-effect waves-circle" data-row-id="10253"><span className="zmdi zmdi-format-list-bulleted"></span></button>
    }

    renderLink(cell , row){
        return <a href={'#/builder/checkout/'+row.catalog_uid} ><i className="zmdi zmdi-link p-r-5"></i> {cell}</a>
    }

    copyButton(cell, row){
        return <Button block>Duplicate</Button>;
    }

    gotoCheckout(id){
        window.location.hash = 'builder/checkout/'+id;
    }

    onVocabSelect(catalog) {
        this.setState({show:true , catalogUID:catalog.catalog_uid});
        ContentService.fetchCatalog(catalog.catalog_uid , catalog.learning_ietf , catalog.support_ietf);
        ContentService.fetchCatalogSummary(catalog.catalog_uid);
    }

    toggleVocab(){
        this.setState({
            show:false,
        })
    }

    date(dateStr){
        //var dateStr="2011-08-03 09:15:11"; //returned from mysql timestamp/datetime field
        var a=dateStr.split(" ");
        var d=a[0].split("-");
        var t=a[1].split(":");
        var myDate = new Date(d[0],(d[1]-1),d[2],t[0],t[1],t[2]);


        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        return pad(myDate.getDate() ,  2) + "-" + pad((myDate.getMonth() + 1) , 2 ) + "-" + myDate.getFullYear().toString().substr(-2);;
    }

    render()
    {
        let warning = null;

        if(this.state.learningLanguage.ietf == this.state.supportLanguage.ietf)
        {
            warning = <Alert bsStyle="warning">
                <strong>Holy guacamole!</strong> This is where the error message if full emersion
            </Alert>
        }


        const tableOptions = {
            page: 1,  // which page you want to show as default

            sizePerPage: 20,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationShowsTotal: false,
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            hideSizePerPage: true,
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast:true,
            firstPage: '...', // First page button text
            lastPage: '...', // Last page button text
            noDataText: InternationalizationStore.getTranslation('ui-2011' , '  '),
        };



        var VocabObjects = [];

        for(var idx = 0 ; idx < this.state.catalog.vocab.length; idx++)
        {
            let vocabObject = this.state.catalog.vocab[idx];
            VocabObjects.push(<Col md={4}><VocabObject vocab={vocabObject}/></Col>);
        }

        return <Layout>

                        <Modal bsSize="large"  show={this.state.show} onHide={this.toggleVocab.bind(this)}>
                            <Modal.Header closeButton>
                                <h4>{this.state.title}</h4>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>{VocabObjects}</Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button  onClick={this.toggleVocab.bind(this)} bsStyle="danger">Close</Button>
                            </Modal.Footer>

                        </Modal>
                        <Card>
                            <CardHead>
                                <div className="row">
                                    <h2 className="">
                                        <FormattedMessage id={"ui-883"} defaultMessage={"Content Libary"} />
                                    </h2>
                                </div>
                            </CardHead>
                            <CardBody noPadding>
                                <div id="ClassRecentActivity">
                                    <div className="">
                                        <BootstrapTable search options={tableOptions} data={ this.state.modules } keyField='uid'  condensed pagination striped bordered={ false }>
                                            <TableHeaderColumn dataSort={ true }  col='0' colSpan='1' dataField='title'   dataFormat={this.renderLink.bind(this)} ><FormattedMessage id={"ui-2202"} defaultMessage={"Title"} /></TableHeaderColumn>
                                            <TableHeaderColumn  col='0' colSpan='1' dataField='description'    dataSort={ false }><FormattedMessage id={"ui-2203"} defaultMessage={"Description"} /></TableHeaderColumn>
                                            <TableHeaderColumn dataSort={ true }  col='0' colSpan='1' dataField='created_dts' dataFormat={this.date.bind(this)}    ><FormattedMessage id={"ui-2206"} defaultMessage={"Created"} /></TableHeaderColumn>

                                            <TableHeaderColumn  col='0' colSpan='1' dataField='state'    dataSort={ false }><FormattedMessage id={"ui-2204"} defaultMessage={"Created"} /></TableHeaderColumn>
                                            <TableHeaderColumn  width='100px' col='0' colSpan='1' row='0' rowSpan='1'  dataField='learning_ietf'  dataFormat={this.languageImage} colSpan='1' dataSort={ false }><FormattedMessage id={"ui-492"} defaultMessage={"Created"} /></TableHeaderColumn>

                                            <TableHeaderColumn width='80px' col='0' colSpan='1' row='0' rowSpan='1'  dataField='catalog_uid'  dataFormat={this.seeButton.bind(this)} colSpan='1' dataSort={ false }></TableHeaderColumn>
                                            <TableHeaderColumn width='80px'  col='0' colSpan='1' row='0' rowSpan='1'  dataField='catalog_uid'  dataFormat={this.editButton.bind(this)} colSpan='1' dataSort={ false }></TableHeaderColumn>

                                        </BootstrapTable>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>

               </Layout>
    }

}


// WEBPACK FOOTER //
// ./src/screens/content-bulider-overview.js